// extracted by mini-css-extract-plugin
export default {"status":"style_status__SopGf","prev":"style_prev__26ija","current":"style_current__fAPdM","next":"style_next__FsYt3"};